export const BasicData = `
    id
    name
`;

export const DropdownMappingFragment = `
    key: id
    value: id
    text: name
`;

export const DropdownData = `
    id
    name
    ${DropdownMappingFragment}
`;

export const FragmentStreamDelayTypeData = `
    fragment StreamDelayTypeData on StreamDelayType {
        id
        name
    }
`;

export const FragmentDeviceCategoryBasicData = `
    fragment DeviceCategoryBasicData on DeviceCategory {
        id
        name
    }
`;

export const FragmentEncodingJobProfilesDropdown = `
    fragment EncodingJobProfilesDropdown on EncodingJobProfile {
        id
        name
        ${DropdownMappingFragment}
    }
`;
